var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendardots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1678_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 4.375H5.25C4.76675 4.375 4.375 4.76675 4.375 5.25V22.75C4.375 23.2332 4.76675 23.625 5.25 23.625H22.75C23.2332 23.625 23.625 23.2332 23.625 22.75V5.25C23.625 4.76675 23.2332 4.375 22.75 4.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 2.625V6.125",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.625V6.125",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.625H23.625",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.3125C14.4832 15.3125 14.875 14.9207 14.875 14.4375C14.875 13.9543 14.4832 13.5625 14 13.5625C13.5168 13.5625 13.125 13.9543 13.125 14.4375C13.125 14.9207 13.5168 15.3125 14 15.3125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 15.3125C19.2957 15.3125 19.6875 14.9207 19.6875 14.4375C19.6875 13.9543 19.2957 13.5625 18.8125 13.5625C18.3293 13.5625 17.9375 13.9543 17.9375 14.4375C17.9375 14.9207 18.3293 15.3125 18.8125 15.3125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 19.6875C9.67075 19.6875 10.0625 19.2957 10.0625 18.8125C10.0625 18.3293 9.67075 17.9375 9.1875 17.9375C8.70425 17.9375 8.3125 18.3293 8.3125 18.8125C8.3125 19.2957 8.70425 19.6875 9.1875 19.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19.6875C14.4832 19.6875 14.875 19.2957 14.875 18.8125C14.875 18.3293 14.4832 17.9375 14 17.9375C13.5168 17.9375 13.125 18.3293 13.125 18.8125C13.125 19.2957 13.5168 19.6875 14 19.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 19.6875C19.2957 19.6875 19.6875 19.2957 19.6875 18.8125C19.6875 18.3293 19.2957 17.9375 18.8125 17.9375C18.3293 17.9375 17.9375 18.3293 17.9375 18.8125C17.9375 19.2957 18.3293 19.6875 18.8125 19.6875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_3186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendardots);
export default __webpack_public_path__ + "static/media/calendardots.a81c3532b5b79c2bc9911e8bbcff4a11.svg";
export { ForwardRef as ReactComponent };